<rma-blog-nav [blogCategories]="categories$ | async" />
<router-outlet />
